import { makeStyles } from "@material-ui/core/styles";
import ArrowIcon from "Assets/images/arrow-down.svg";

const useStyles = makeStyles(() => ({
  root: {
    "& .k-selected-color": {
      borderRadius: "5px",
      height: "25px",
      width: "25px",
      margin: 0,
    },
    "& .k-picker-wrap": {
      border: "solid 1px #EDEDED !important",
      width: 70,
      borderRadius: 4,
      padding: "7px 10px",
      "&:hover": {
        borderColor: "rgba(0, 0, 0, 0.87) !important",
      },
      "&.k-state-focused": {
        boxShadow: "0px 1px 6px #FFD47099",
        borderColor: "#F3994E !important",
      },
    },
    "& .k-colorpicker .k-select": {
      padding: 0,
      opacity: 1,
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      "& .k-icon": {
        width: "auto",
        marginLeft: 30,
      },
    },
    "& .k-i-arrow-s::before": {
      content: "''",
      backgroundImage: `url(${ArrowIcon})`,
      backgroundRepeat: "no-repeat",
      width: 20,
      height: 22,
    },
  },
  formLabel: {
    fontWeight: 500,
    marginBottom: "5px !important",
    lineHeight: "20px !important",
  },
  colorPicker: {
    width: "108px",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
    "& .k-colorpalette": {
      padding: "0px !important",
    },
    "& table": {
      "&:before": {
        color: "#767677",
        left: "47px",
        bottom: "20px",
        position: "absolute",
        content: "'No fill'",
      },
      borderSpacing: "8px",
      borderCollapse: "separate !important",
      "& td": {
        borderRadius: "5px",
      },
    },
  },
}));

export default useStyles;
